document.addEventListener('DOMContentLoaded', () => {
  const reelsSection = document.querySelector('[data-reels-section]');
  if (!reelsSection) return;

  const muteBtns = reelsSection.querySelectorAll('.reels-section__mute-btn');
  muteBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const videoWrap = btn.closest('.reels-section__video-wrap');
      const video = videoWrap?.querySelector('video');
      if (!video) return;

      video.muted = !video.muted;
      btn.classList.toggle('is-unmuted', !video.muted);
    });
  });

  // TODO: Modal popup for block data-info (title, description, button)
  // TODO: Slider/swipe navigation for .reels-section__slider
});
